module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Mailbox-1a59e3bddbb5071e5ef2f4fb7b28f75e.svg";